import React, { Component } from 'react';
import './Footer.css';
import FbIcon from '../imgs/inverted/Facebook.png'
import { Link } from 'react-router-dom';

export default class Footer extends Component {
  render() {
    return (
      <footer className="footer">
        <div className="container">
          <ul>
            <li>
            <Link className="nav-link" to="/facebook"></Link>
            </li>
          </ul>
        </div>
      </footer>
    );
  }
}


